module.exports = __webpack_public_path__ + "img/roscon-de-reyes.cd82fd11.svg";